// extracted by mini-css-extract-plugin
module.exports = {"ranking-section":"ranking-section","header-title":"header-title"};